import { Modal } from '@/ui/modal/modal';
import { AskToJoinForm } from '../ask-to-join/ask-to-join-form';
import { modalState } from '@/state/modal.state';
import { useAtom } from 'jotai';

export const AskToJoinFormModal = () => {
  const [modal, setModal] = useAtom(modalState);

  const closeModal = () => setModal(null);

  if (!modal || modal.state !== 'askToJoinForm') return null;

  return (
    <Modal onClose={closeModal}>
      <AskToJoinForm
        linkId={modal.linkId}
        organizationName={modal.organizationName}
        spotlightLinkId={modal.spotlightLinkId}
      />
    </Modal>
  );
};
